import React from 'react';
import './OverviewStatsCards.css';

const OverviewStatsCards = ({ stats }) => {
  const formatCurrency = (amount) => {
    return `Rs. ${amount.toLocaleString()}`;
  };

  return (
    <div className="overview-stats-cards">
      <div className="overview-stat-card">
        <div className="stat-icon-wrapper blue">
          <span className="stat-icon">📦</span>
        </div>
        <div className="stat-content-wrapper">
          <div className="stat-number-large">{stats.totalOrders.toLocaleString()}</div>
          <div className="stat-label-large">Total Orders</div>
          <div className={`stat-comparison ${stats.ordersChange >= 0 ? 'positive' : 'negative'}`}>
            <span className="comparison-icon">{stats.ordersChange >= 0 ? '↑' : '↓'}</span>
            <span>vs previous period: {stats.ordersChange >= 0 ? '+' : ''}{stats.ordersChange}%</span>
          </div>
        </div>
      </div>

      <div className="overview-stat-card">
        <div className="stat-icon-wrapper blue">
          <span className="stat-icon">💰</span>
        </div>
        <div className="stat-content-wrapper">
          <div className="stat-number-large">{formatCurrency(stats.totalRevenue)}</div>
          <div className="stat-label-large">Total Revenue</div>
          <div className={`stat-comparison ${stats.revenueChange >= 0 ? 'positive' : 'negative'}`}>
            <span className="comparison-icon">{stats.revenueChange >= 0 ? '↑' : '↓'}</span>
            <span>{stats.revenueChange >= 0 ? '+' : ''}{stats.revenueChange}%</span>
          </div>
        </div>
      </div>

      <div className="overview-stat-card">
        <div className="stat-icon-wrapper blue">
          <span className="stat-icon">📊</span>
        </div>
        <div className="stat-content-wrapper">
          <div className="stat-number-large">{formatCurrency(stats.avgOrderValue)}</div>
          <div className="stat-label-large">Avg Order Value</div>
          <div className={`stat-comparison ${stats.aovChange >= 0 ? 'positive' : 'negative'}`}>
            <span className="comparison-icon">{stats.aovChange >= 0 ? '↑' : '↓'}</span>
            <span>{stats.aovChange >= 0 ? '+' : ''}{stats.aovChange}%</span>
          </div>
        </div>
      </div>

      <div className="overview-stat-card">
        <div className="stat-icon-wrapper blue">
          <span className="stat-icon">👥</span>
        </div>
        <div className="stat-content-wrapper">
          <div className="stat-number-large">{stats.customerCount.toLocaleString()}</div>
          <div className="stat-label-large">Total Customers</div>
          <div className="stat-new-customers">
            +{stats.newCustomers} new
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewStatsCards;

